var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 19.1667H19.3333V9.6875L12.8333 13.75L6.33333 9.6875V19.1667H4.16667V6.16667H5.46667L12.8333 10.7708L20.2 6.16667H21.5V19.1667ZM21.5 4H4.16667C2.96417 4 2 4.96417 2 6.16667V19.1667C2 19.7413 2.22827 20.2924 2.6346 20.6987C3.04093 21.1051 3.59203 21.3333 4.16667 21.3333H21.5C22.0746 21.3333 22.6257 21.1051 23.0321 20.6987C23.4384 20.2924 23.6667 19.7413 23.6667 19.1667V6.16667C23.6667 5.59203 23.4384 5.04093 23.0321 4.6346C22.6257 4.22827 22.0746 4 21.5 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.030b1f868084edf3c691015eb612606f.svg";
export { ForwardRef as ReactComponent };